/**
 * Black-Swan Plugin Core
 *
 * @since: 2017-11-23
 * @author: kdydesign.kim
 */

import Vue from 'vue'

// global components
import * as Components from './components/index'

// global components
Vue.component('alert-dialog', Components.AlertDialog)
Vue.component('confirm-dialog', Components.ConfirmDialog)
Vue.component('loading-dialog', Components.LoadingDialog)
Vue.component('validate-dialog', Components.ValidateDialog)
Vue.component('duplicate-confirm-dialog', Components.DuplicateConfirmDialog)
Vue.component('tool-tip', Components.ToolTip)
Vue.component('edit-panel', Components.EditPopupPanel)

// // TODO: 정리 필요
// // loading 팝업 plugin prototype 등록
// const LoadingPopUp = {
//   install (Vue, options = {}) {
//     var ModalConstructor = Vue.extend(Components.LoadingDialog)
//     var modalInstance = null
//
//     if (this.installed) {
//       return
//     }
//
//     this.installed = true
//     this.event = new Vue()
//
//     Vue.prototype.$loader = {
//       show (opts, type, noHide) {
//         if (this.loaderModalInstance) {
//           this.loaderModalInstance.show(opts, type, noHide)
//           return
//         }
//
//         this.loaderModalInstanceCreate()
//         this.loaderModalInstance.show(opts, type, noHide)
//       },
//       hide () {
//         LoadingPopUp.event.$emit('hide')
//       },
//       loaderModalInstanceCreate () {
//         modalInstance = new ModalConstructor({
//           el: document.createElement('div')
//         })
//         document.body.appendChild(modalInstance.$el)
//         this.loaderModalInstance = modalInstance
//       },
//       loaderModalInstanceDestroy () {
//         if (modalInstance.$el.parentNode) {
//           modalInstance.$el.parentNode.removeChild(modalInstance.$el)
//         }
//         modalInstance = null
//         this.loaderModalInstance = null
//       },
//       loaderModalInstance: null
//     }
//   }
// }

// TODO: 위 코드로 실행 시, 전체적인 화면 이상 발생됨. (TAMS, 적용 보류)
const LoadingPopUp = {
  install (Vue, options = {}) {
    if (this.installed) {
      return
    }

    this.installed = true
    this.event = new Vue()

    Vue.prototype.$loader = {
      show (opts) {
        LoadingPopUp.event.$emit('show', opts)
      },

      hide (message) {
        LoadingPopUp.event.$emit('hide', message)
      }
    }
  }
}

const ValidatePopUp = {
  install (Vue, options = {}) {
    var ModalConstructor = Vue.extend(Components.ValidateDialog)
    var modalInstance = null

    if (this.installed) {
      return
    }

    this.installed = true
    this.event = new Vue()

    Vue.prototype.$validatePopUp = {
      show (errorBag, customErrMsgs = []) {
        if (modalInstance) {
          modalInstance.show(errorBag, customErrMsgs)
          return
        }

        modalInstance = new ModalConstructor({
          el: document.createElement('div')
        })

        document.body.appendChild(modalInstance.$el)
        modalInstance.show(errorBag, customErrMsgs)
      },

      hide () {
        ValidatePopUp.event.$emit('hide')
      }
    }
  }
}

const AlertPopUp = {
  install (Vue, options = {}) {
    var ModalConstructor = Vue.extend(Components.AlertDialog)
    var modalInstance = null

    if (this.installed) {
      return
    }

    this.installed = true
    this.event = new Vue()

    Vue.prototype.$alertPopUp = {
      show (opts, type, noHide) {
        if (modalInstance) {
          modalInstance.show(opts, type, noHide)
          return
        }

        modalInstance = new ModalConstructor({
          el: document.createElement('div')
        })

        document.body.appendChild(modalInstance.$el)
        modalInstance.show(opts, type, noHide)
        // ConfirmPopUp.event.$emit('show', opts)
      },

      hide () {
        // ConfirmPopUp.event.$emit('hide')
      }
    }
  }
}

Vue.use(LoadingPopUp)
Vue.use(ValidatePopUp)
Vue.use(AlertPopUp)

export {
  LoadingPopUp,
  ValidatePopUp,
  AlertPopUp
}
